export default __webpack_public_path__ + "static/media/kido-village-logo.19e109b7.png";